import type { Language } from '@nxt-insurance/constants'
import { SupportedMarketKey } from '@nxt-insurance/constants'

import { getFlowConfiguration } from '@flows/configs/shared/flowConfiguration'
import {
  appointmentDetailsSchema,
  appointment_details,
} from '@flows/configs/shared/mgaLight/steps/appointmentDetails'
import { getLoginSchema, login } from '@flows/configs/shared/mgaLight/steps/login'
import { phoneNumberConfirmation } from '@flows/configs/shared/mgaLight/steps/phoneConfirmation'
import { progressFirstStep } from '@flows/configs/shared/mgaLight/steps/progressFirstStep'
import type { AnySteps } from '@flows/core/types/stepTypes'
import { generateGetFlowValueFunctions } from '@flows/insurance/utils'

import { PUBLIC_INSURANCES } from './constants'
import { employmentStatus } from './steps/employmentStatus'
import { includeKids } from './steps/includeKids'
import { income } from './steps/income'
import { previousInsurer } from './steps/previousInsurer'
import { progressLastStep } from './steps/progressLastStep'
import { success } from './steps/success'
import { publicHealthSchema } from './types'

const helperFunctions = generateGetFlowValueFunctions('mga_public_health_de')
const schema = publicHealthSchema.merge(getLoginSchema()).merge(appointmentDetailsSchema)

export const getPublicHealthConfig = (args: {
  getCurrentLanguage: () => Language
  platform: 'web' | 'native'
  environment: string
}) => {
  const params = {
    helperFunctions,
    schema,
    getCurrentLanguage: args.getCurrentLanguage,
    platform: args.platform,
    environment: args.environment,
  }
  const steps = {
    // TODO: This step is temporarily not used. But we don't plan to completely remove it, therefore the code should remain here
    // This will be re-checked in the scope of this ticket: https://hellogetsafe.atlassian.net/browse/IA-540
    progress_first_step: progressFirstStep({
      platform: args.platform,
      nextStep: 'previous_insurer',
    }),
    previous_insurer: previousInsurer(params),
    employment_status: employmentStatus(params),
    income: income(params),
    include_kids: includeKids(params),
    login: login({ market: SupportedMarketKey.De, platform: args.platform }),
    phone_confirmation: phoneNumberConfirmation({ market: SupportedMarketKey.De }),
    progress_last_step: progressLastStep(params),
    success: success(params),
    appointment_details: appointment_details({
      type: 'translatableText',
      translationKey: 'sharedFlows_publicHealth:title',
    }),
  } as const satisfies AnySteps
  return getFlowConfiguration(steps, {
    constants: {
      flowName: 'public-health',
      SCHEMA: schema,
      FIRST_STEP_NAME: 'previous_insurer',
      productKey: 'mga_public_health_de',
      PUBLIC_INSURANCES,
    },
  })
}
